<template>
<div class="k-page-content">
	<div class="messageIndex">
		<div class="left box">
			<div class="title">
				<span class="t1">消息</span>
				<!-- <span class="t2" @click="readAll()">一键已读 <i class="el-icon-thumb"></i></span> -->
			</div>
			<div class="fenlei">
				<span>分类</span>
				<el-button
				      v-for="(btn, index) in buttons"
				      :key="index"
				      :type="getButtonType(index)"
				      :plain="isButtonPlain(index)"
				      @click="toggleButton(index)"
				      size="mini"
				      round
				    >
				      {{ btn.text }}
				    </el-button>
			</div>
			<ul class="con" v-if="tableData.data.length > 0">
				<li v-for="(item,index) in tableData.data" :key="index" @click="getDetail(item)">
					<div :class="item.send_name_jian == '系统' ? 'name two' : 'name'">{{item.send_name_jian}}</div>
					<div class="content">
						<span class="read" v-if="item.is_read == 0"></span>
						<p class="t1">{{item.title}}</p>
						<p class="t2">
							<span>发件人：{{item.send_name}}</span>
							<span>{{item.send_time}}</span>
						</p>
					</div>
				</li>
				<el-pagination
					background
					ref="pagination"
					@current-change="handleCurrentChange"
					:current-page="tableData.page | number"
					:page-size="tableData.pagesize | number"
					layout="total, prev, pager, next"
					:total="tableData.total | number">
				</el-pagination>
			</ul>
			<div v-else>
				暂无数据
			</div>
		</div>
		<div class="right box" style="display: none;">
			<div class="title">
				<span class="t1">公告</span>
				<span class="t2">查看更多<i class="el-icon-arrow-right"></i></span>
			</div>
			<ul class="notice">
				<li>
					<p>消息消息消息消息消息消息消息消息消息消息消息消息消息消息消息消息消息消息消息消息</p>
					<span>2024-3-28</span>
				</li>
			</ul>
		</div>
	</div>
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
      return {
		  loading:false,
		  tableData: {
		      total: 0,
		      pagesize: 20,
		      page: 1,
		      data: []
		  },
		  activeButtonIndex: 0,
		  buttons: [
			  { text: '全部' },
			  { text: '系统消息' },
			  { text: '审批提醒' },
			  { text: '业务提醒' }
		  ],
      }
	},
	computed: {
		
	},
	mounted: function () {
		this.handleSearch()
	},
	methods: {
		readAll(){
			this.$api.post('/admin/news/message/readall').then(res => {
				if (res.code === 0) {
				  this.handleSearch()
			  } else {
				 this.$message.error(res.msg);
			  }
			})
		},
		handleSearch: function (params, page, prop, order) {
		  this.loading = true;
		  var param = Object.assign({}, params);
		  param['page'] = page ? page : 1;
		  param['pagesize'] = this.tableData.pagesize;
		  if(this.activeButtonIndex > 0){
			  param.type = this.activeButtonIndex
		  }
		  this.$api.get('/admin/news/message/list',param).then(res => {
			  if (res.code === 0) {
				  this.tableData = res.data;
				  this.tableData.data.forEach((item,index) => {
					  if(item.send_name != '系统'){
						  this.$set(this.tableData.data[index],'send_name_jian',item.send_name.charAt(0))
					  }else{
						  this.$set(this.tableData.data[index],'send_name_jian',item.send_name)
					  }
				  })
				  this.loading = false
			  } else {
				 this.$message.error(res.msg);
			  }
			  this.loading = false
		  })
		},
		// 改变当前页 page
		handleCurrentChange(val) {
			this.handleSearch('', val);
		},
		toggleButton(index) {
		    this.activeButtonIndex = this.activeButtonIndex === index ? '' : index;
			this.handleSearch()
		},
		getButtonType(index) {
		    return this.activeButtonIndex === index ? 'primary' : '';
		},
		isButtonPlain(index) {
		    return this.activeButtonIndex === index;
		},
		getDetail(row){
			this.$api.get('/admin/news/message/info',{id:row.id}).then(res => {
			  if (res.code === 0) {
				  if(row.type == 2){
				  	this.$router.push({
				  		name: 'Checklist',
						query:{ type: row.status}
				  	});
				  }else{
					 this.$router.push({
					 	name: 'MessageDetail',
					 	query:{ id: row.id}
					 }); 
				  }
			  } else {
				 this.$message.error(res.msg);
			  }
			})
			// this.$api.get('/admin/news/message/info',{id:row.id}).then(res => {
			//   if (res.code === 0) {
			// 	  this.tableData.data.forEach((item,index) => {
			// 		  if(item.id == row.id){
			// 			  this.$set(this.tableData.data[index],'is_read',1)
			// 		  }
			// 	  })
			// 	  this.loading = false
			//   } else {
			// 	 this.$message.error(res.msg);
			//   }
			//   this.loading = false
			// })
		}
	}
}
</script>
<style lang="scss" scoped>
	.messageIndex{
		padding: 20px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		.box{
			background-color: #fff;
			box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.05);
			border-radius: 2px;
			min-height: calc(100vh - 110px);
			padding: 0 20px;
			box-sizing: border-box;
		}
		.left{
			width: 100%;
			position: relative;
		}
		.right{
			width: 390px;
			margin-left: 20px;
		}
		.title{
			height: 52px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #E6E6E6;
			.t1{
				color: #262626;
				font-size: 16px;
				font-weight: 500;
				display: flex;
				position: relative;
				height: 52px;
				padding-left: 10px;
				align-items: center;
				&::before{
					content: "";
					display: inline-block;
					width: 3px;
					border-radius: 15px;
					height: 18px;
					margin-right: 6px;
					background-color: #2f88ff;
				}
			}
			.t2{
				font-size: 14px;
				color: #2f88ff;
				cursor: pointer;
			}
		}
		.con{
			padding: 10px 0;
			height: calc(100vh - 300px);
			overflow: auto;
			.el-pagination{
				position: absolute;
				right: 10px;
				bottom: 10px;
			}
			li{
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 10px 0;
				cursor: pointer;
				.name{
					width: 40px;
					height: 40px;
					background: #5E98FF;
					border-radius: 100%;
					display: inline-flex;
					align-items: center;
					justify-content: center;
					font-weight: 500;
					font-size: 20px;
					color: #FFFFFF;
					&.two{
						font-size: 14px;
					}
				}
				.content{
					flex: 1;
					margin-left: 10px;
					overflow: hidden;
					position: relative;
					.t1{
						font-weight: 500;
						font-size: 14px;
						color: #5A626B;
						line-height: 20px;
						height: 20px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						margin-bottom: 9px;
						width:calc(100% - 20px);
					}
					.t2{
						font-weight: 400;
						font-size: 13px;
						color: #AAAAAA;
						line-height: 18px;
						display: flex;
						justify-content: space-between;
					}
					.read{
						width: 10px;
						height: 10px;
						background: #FF5150;
						border-radius: 100%;
						position: absolute;
						right: 0;
						top: 4px;
					}
				}
			}
		}
		.notice{
			padding: 14px 0;
			li{
				display: flex;
				justify-content: space-between;
				height: 32px;
				align-items: center;
				p{
					font-weight: 500;
					font-size: 14px;
					color: #5A626B;
					height: 32px;
					line-height: 32px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					width:calc(100% - 80px);
					display: block;
				}
				span{
					font-weight: 500;
					font-size: 13px;
					color: #AAAAAA;
				}
			}
		}
		.fenlei{
			display: flex;
			align-items: center;
			padding: 20px 0;
			span{
				display: inline-flex;
				font-size: 14px;
				font-weight: bold;
				margin-right: 20px;
			}
		}
	}
</style>